export default {
    appVersion: "1.7.0-ci.20261019.12",
    apiVersion: "1.6",
  }